import { render, staticRenderFns } from "./ShCharts.md?vue&type=template&id=64051f80"
import script from "./ShCharts.md?vue&type=script&lang=js"
export * from "./ShCharts.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports